module.exports = __webpack_public_path__ + "img/one.668047fc.png";